/** 全站與各頁 SEO meta（keywords / description） */

const BASE_KEYWORDS =
    '程式接案,專案外包,軟體外包,客製化軟體開發,委外軟體開發';

const AI_KEYWORDS =
    'AI 應用,AI 應用系統,進銷存,AI 進銷存,智慧進銷存管理系統';

export const defaultSeo = {
    keywords: `${BASE_KEYWORDS},${AI_KEYWORDS}`,
    description:
        '提供程式軟體開發人力需求，解決客戶在資訊系統開發與維護不同階段的人力資源需求。匯融擁有超過 15 年委外軟體開發、教育訓練、資訊系統整合與維護經驗，並提供 AI 應用、進銷存等客製化方案，客戶遍及製造業、科技業、一般企業及政府部門。',
};

export const successCaseSeo = {
    keywords: `${BASE_KEYWORDS},成功案例,AI 應用,進銷存,AI 進銷存,派工維修,長照系統,政府資訊系統`,
    description:
        '匯融科技成功案例：半導體、製造科技、零售長照與政府單位之客製化軟體開發實績，涵蓋 AI 應用系統、智慧進銷存、Web／PDA 與表單簽核等專案類型。',
};

export const aiServicesSeo = {
    keywords: `${BASE_KEYWORDS},AI 應用,AI 應用系統,智能客服,LLM,RAG,文件辨識,OCR,企業知識庫`,
    description:
        '匯融科技 AI 應用系統服務：智能客服、企業知識庫、文件辨識流程與電子零件查價，以 LLM 與 RAG 協助企業提升客服與採購決策效率，可串接進銷存與訂單系統。',
};

export const aiInventorySeo = {
    keywords: `${BASE_KEYWORDS},進銷存,AI 進銷存,智慧進銷存,ERP,訂單管理,採購管理,庫存管理,AI 對話查詢`,
    description:
        '匯融科技 AI 進銷存管理系統：整合訂單、採購、庫存與 AI 語意對話，以自然語言查詢報表與庫存，打造智慧進銷存與企業數據決策中樞。',
};
